import DashboardLayout from '../layout/DashboardLayout.vue'
import Login from '../pages/Login.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import DTao from "src/pages/TaoProgram/DashboardTao.vue";
import DTaoDom from "src/pages/TaoProgram/DashboardTaoDomisili.vue";
import DHuang from "src/pages/TaoProgram/DashboardHuang.vue";
import Dashboard from "src/pages/TaoProgram/Dashboard.vue";
import Master from "src/pages/TaoProgram/MasterData.vue";
import MUser from "src/pages/TaoProgram/MasterUser.vue";
import UserRegis from "src/pages/TaoProgram/UserRegis.vue"
import ApprovalTao from "src/pages/TaoProgram/ApprovalTao.vue"
import UploadTao from "src/pages/TaoProgram/UploadTao.vue"
import UploadHuang from "src/pages/TaoProgram/UploadHuang.vue"
import MasterEvent from "src/pages/TaoProgram/MasterEvent.vue"
import MasterPengumuman from "src/pages/TaoProgram/MasterPengumuman.vue"

import CetakReport from "src/pages/TaoProgram/CetakReport.vue"
import CetakReportApproval from "src/pages/TaoProgram/CetakReportApproval.vue"
// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import Icons from 'src/pages/Icons.vue'


const routes = [
  {
    path: '/',
    name: "Login",
    component: Login,
  },
  
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/dash',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'dash',
        name: 'Dash',
        component: Dashboard
      },
      {
        path: "dashTao",
        name: "DTao",
        component: DTao
      //   ,meta: { requireAuth: true }
      },
      {
        path: "dashHuang",
        name: "DHuang",
        component: DHuang
        // ,meta: { requireAuth: true }
      },
      {
        path: 'master',
        name: 'Master',
        component: Master
      },
      {
        path: 'muser',
        name: 'MUser',
        component: MUser
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'ureg',
        name: "UserRegis",
        component: UserRegis,
      },
      {
        path: 'approvalTao',
        name: "ApproveTao",
        component: ApprovalTao,
      },
      {
        path: 'uploadTao',
        name: "UploadTao",
        component: UploadTao,
      },
      {
        path: 'uploadHuang',
        name: "UploadHuang",
        component: UploadHuang,
      },
      {
        path: 'cetakReport',
        name: "CetakReport",
        component: CetakReport,
      },
      {
        path: 'cetakReportapproval',
        name: "CetakReportApproval",
        component: CetakReportApproval,
      },
      {
        path: 'dashTaodom',
        name: "DTaodom",
        component: DTaoDom,
      },
      {
        path: 'masterevent',
        name: 'MasterEvent',
        component: MasterEvent,
      },
      {
        path: 'masterpengumuman',
        name: 'MasterPengumuman',
        component: MasterPengumuman
      }
    ]
  },
  
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
